
export const companyStats = [
  { number: '1+', label: '운영 연수', icon: 'ri-calendar-check-line' },
  { number: '350+', label: '만족한 여행객', icon: 'ri-group-line' },
  { number: '15+', label: '투어 상품', icon: 'ri-compass-3-line' },
  { number: '4.9', label: '평균 평점', icon: 'ri-star-line' },
];

export const companyTimeline = [
  {
    year: '2024.01',
    title: '봉구 투어 설립',
    description: '필리핀 세부에서 한국인 여행객을 위한 맞춤형 투어 서비스를 시작했습니다. 젊고 열정적인 팀과 함께 아일랜드 호핑 투어로 첫 발을 내딛었습니다.',
  },
  {
    year: '2024.04',
    title: '투어 상품 확대',
    description: '오슬롭 고래상어, 카와산 폭포, 보홀 당일 투어 등 다양한 상품을 추가하며 빠르게 사업을 확장했습니다.',
  },
  {
    year: '2024.07',
    title: '100명 돌파',
    description: '설립 6개월 만에 누적 여행객 100명을 돌파하며 세부 현지에서 빠르게 성장하는 신생 여행사로 주목받았습니다.',
  },
  {
    year: '2024.10',
    title: '프리미엄 서비스 런칭',
    description: 'VIP 프라이빗 투어, 드론 촬영 서비스 등 프리미엄 라인업을 선보이며 차별화된 서비스를 제공하기 시작했습니다.',
  },
  {
    year: '2025.01',
    title: '350명 돌파 & AI 상담 시스템',
    description: '1년 만에 누적 여행객 350명을 돌파하고, 24시간 온라인 예약 시스템과 AI 상담 서비스를 도입했습니다.',
  },
];

export const coreValues = [
  {
    icon: 'ri-shield-check-line',
    title: '안전 최우선',
    description: '모든 투어에 안전 장비를 완비하고, 응급 상황 대비 매뉴얼을 철저히 준수합니다. 여행자 보험 가입을 필수로 안내합니다.',
    color: '#E0F7FA',
    iconColor: '#00BCD4',
  },
  {
    icon: 'ri-heart-3-line',
    title: '고객 감동',
    description: '단순한 관광이 아닌, 평생 기억에 남을 특별한 경험을 선사합니다. 세심한 배려와 맞춤형 서비스로 감동을 드립니다.',
    color: '#FFF3E0',
    iconColor: '#FF9800',
  },
  {
    icon: 'ri-earth-line',
    title: '현지 전문성',
    description: '세부 현지 네트워크와 최신 정보를 바탕으로 가장 정확하고 생생한 여행 정보를 제공합니다.',
    color: '#E8F5E9',
    iconColor: '#4CAF50',
  },
  {
    icon: 'ri-hand-coin-line',
    title: '합리적 가격',
    description: '중간 마진 없이 현지 직영 운영으로 최저가를 보장합니다. 투명한 가격 정책으로 숨겨진 비용이 없습니다.',
    color: '#FCE4EC',
    iconColor: '#E91E63',
  },
];

export const teamMembers = [
  {
    name: '김봉구',
    role: '대표 / 수석 가이드',
    description: '세부 거주 5년차. 필리핀 관광부 공인 가이드 자격 보유. 젊은 열정으로 최고의 투어를 만들어가는 베테랑입니다.',
    image: 'https://public.readdy.ai/ai/img_res/8233e5f3c7827eed435107b666445b21.jpg',
  },
  {
    name: '마리아 산토스',
    role: '현지 코디네이터',
    description: '세부 출신 현지인으로 한국어 능통. 숙소, 교통, 레스토랑 등 현지 파트너 관리를 담당합니다.',
    image: 'https://readdy.ai/api/search-image?query=friendly%20filipina%20woman%20in%20her%2030s%20wearing%20professional%20casual%20outfit%20smiling%20warmly%20tourism%20coordinator%20cebu%20philippines%20tropical%20setting%20simple%20clean%20background&width=400&height=500&seq=team2&orientation=portrait',
  },
  {
    name: '박지훈',
    role: '해양 액티비티 전문 가이드',
    description: 'PADI 다이빙 강사 자격 보유. 스노클링, 다이빙, 카약 등 모든 해양 액티비티를 안전하게 이끕니다.',
    image: 'https://readdy.ai/api/search-image?query=athletic%20korean%20male%20diving%20instructor%20in%20his%2030s%20wearing%20wetsuit%20top%20smiling%20confidently%20near%20ocean%20cebu%20philippines%20professional%20sporty%20look%20simple%20clean%20background&width=400&height=500&seq=team3&orientation=portrait',
  },
  {
    name: '이하나',
    role: '고객 상담 매니저',
    description: '예약 상담부터 여행 후 피드백까지 고객 여정 전체를 관리합니다. 카카오톡 24시간 상담 담당.',
    image: 'https://readdy.ai/api/search-image?query=professional%20korean%20woman%20in%20her%20late%2020s%20wearing%20smart%20casual%20outfit%20smiling%20warmly%20customer%20service%20manager%20office%20setting%20simple%20clean%20background&width=400&height=500&seq=team4&orientation=portrait',
  },
];

export const partnerLogos = [
  { name: '필리핀 관광부', icon: 'ri-government-line' },
  { name: '세부 관광청', icon: 'ri-building-2-line' },
  { name: '한국관광공사', icon: 'ri-global-line' },
  { name: 'PADI', icon: 'ri-anchor-line' },
  { name: '세부 호텔 협회', icon: 'ri-hotel-line' },
];
